// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"SampleHistory_wrapper__AIZCn","headerForm":"SampleHistory_headerForm__2AwMG","fetchButton":"SampleHistory_fetchButton__3veWn","batches":"SampleHistory_batches__2f2vp"};